






import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component
export default class CommonButton extends Vue {
  @Prop({default: 'primary'}) private readonly type: string;
  @Prop({default: 'small'}) private readonly size: string;
  @Prop({default: ''}) private readonly label: string;
  @Prop({default: false}) private readonly circle: boolean;
  @Prop({default: false}) private readonly disabled: boolean;
  @Prop({default: false}) private readonly loading: boolean;

  private innerLoading: boolean = false;

  get isLoading() {
    return this.loading || this.innerLoading;
  }

  get buttonLabel() {
    return this.label;
  }

  get buttonType() {
    return this.type;
  }

  get buttonSize() {
    return this.size;
  }

  get isCircle() {
    return this.circle;
  }

  get isDisabled() {
    return this.disabled;
  }

  public switchOn() {
    this.innerLoading = true;
  }

  public switchOff() {
    this.innerLoading = false;
  }


  public onClick($event: any) {
    this.$store.commit('setActionButtonDown', false);
    if (this.isLoading) {
      return;
    }
    this.$emit('click', $event);
    this.$emit('switch', {
      $event,
      on: this.switchOn,
      off: this.switchOff
    });
  }

  public focus() {
    const element: any = this.$refs.elementRef;
    element.$el.focus();
  }

  public onMouseDown($event: any) {
    this.$emit('mousedown', $event);
  }
}
